import { useApiClient } from '../../hooks/useApiClient.ts';
import { County } from '../../types/County.type.ts';
import { GetCountyBuilderCatalogTypesParams, GetCountyQueryParams } from '../../types/QueryParams.type.ts';
import { CountyBuilderCatalogType } from '../../types/SimilarlySituated/CountyBuilderCatalogType.type.ts';
import { buildQueryString } from '../../utils/buildQueryString.ts';

export const useCountyApi = () => {
  const apiClient = useApiClient();

  return {
    getCounties: (params: GetCountyQueryParams): Promise<County[]> => {
      const queryString = buildQueryString(params);

      return apiClient(`/counties/${queryString}`);
    },
    getAssignedCounties: (): Promise<County[]> => apiClient(`/counties/assigned`),
    getCountyBuilderCatalogTypes: (
      countyId: number,
      params: GetCountyBuilderCatalogTypesParams,
    ): Promise<CountyBuilderCatalogType[]> => {
      const queryString = buildQueryString(params);

      return apiClient(`/counties/${countyId}/builder_catalog_types${queryString}`);
    },
  };
};
